module.exports = __webpack_public_path__ + "media/images/top/budget_table/kojin_sp_over3000-d240fdf6a212d1d14ae4e4ab75c91aec.png";